const SHOPIFY_CHECKOUT_DOMAIN = 'checkout.skinvault.be';
const SHOPIFY_STORE_PERMANENT_DOMAIN = 'skin-style-studio-rklte.myshopify.com';

const STOREFRONT_DOMAINS = [
  'skinvault.be',
  'skin-vault.fr',
  'skin-vault.info',
  'skinvault.fr',
];

/**
 * Keep Shopify's complete cart path and token, but always open legacy
 * SkinVault and Online Store URLs on the checkout domain configured in Shopify.
 *
 * The permanent myshopify.com host runs SkinVault's headless redirect theme,
 * so opening a cart there sends the customer back to the storefront homepage.
 * checkout.skinvault.be is the Shopify-hosted payment domain and must be used
 * for both newly-created and previously persisted carts.
 */
export function normalizeCheckoutUrl(checkoutUrl: string): string | null {
  try {
    const url = new URL(checkoutUrl);
    const hostname = url.hostname.toLowerCase();

    if (url.protocol !== 'https:') return null;

    const needsCheckoutHost =
      hostname === SHOPIFY_STORE_PERMANENT_DOMAIN ||
      STOREFRONT_DOMAINS.some(
        (domain) => hostname === domain || hostname === `www.${domain}`
      );

    if (needsCheckoutHost) {
      url.hostname = SHOPIFY_CHECKOUT_DOMAIN;
      url.port = '';
      return url.toString();
    }

    const isHostedCheckout =
      hostname === SHOPIFY_CHECKOUT_DOMAIN ||
      hostname === 'checkout.shopify.com' ||
      hostname === 'shop.app';

    return isHostedCheckout ? url.toString() : null;
  } catch {
    return null;
  }
}
